/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type OrderValidatorType =
  typeof OrderValidatorType[keyof typeof OrderValidatorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderValidatorType = {
  INTERNAL_ORDER_PROCESSING_FAILURE: 'INTERNAL_ORDER_PROCESSING_FAILURE',
  NONE: 'NONE',
  INTENDED_PLATFORM_PRODUCT: 'INTENDED_PLATFORM_PRODUCT',
  CLOSED_PRODUCT: 'CLOSED_PRODUCT',
  SOFT_CLOSED_PRODUCT: 'SOFT_CLOSED_PRODUCT',
  TRANCHE_PRODUCT_DEPOSIT: 'TRANCHE_PRODUCT_DEPOSIT',
  PRODUCT_AVAILABILITY: 'PRODUCT_AVAILABILITY',
  MAX_AVAILABLE: 'MAX_AVAILABLE',
  CANCELLED_ORDER: 'CANCELLED_ORDER',
  CUSTOMER_VERIFICATION: 'CUSTOMER_VERIFICATION',
  MAX_DEPOSIT: 'MAX_DEPOSIT',
  MIN_DEPOSIT: 'MIN_DEPOSIT',
  TAX_WRAPPER: 'TAX_WRAPPER',
  ACCOUNT_HOLDER_TYPE: 'ACCOUNT_HOLDER_TYPE',
  TERM_WITHDRAWAL: 'TERM_WITHDRAWAL',
  WITHDRAWAL_AMOUNT: 'WITHDRAWAL_AMOUNT',
  FULL_WITHDRAWAL_EXISTS: 'FULL_WITHDRAWAL_EXISTS',
  DEPOSIT_EXISTS_FOR_FULL_WITHDRAWAL: 'DEPOSIT_EXISTS_FOR_FULL_WITHDRAWAL',
  NEGATIVE_AMOUNT: 'NEGATIVE_AMOUNT',
  PRODUCT_ACCESS: 'PRODUCT_ACCESS',
  PLACEHOLDER_ACCOUNT_ORDER: 'PLACEHOLDER_ACCOUNT_ORDER',
  INCORRECT_DECIMAL_POINTS: 'INCORRECT_DECIMAL_POINTS',
  NON_UNIQUE_REFERENCE: 'NON_UNIQUE_REFERENCE',
  PARTIAL_NOTICE_WITHDRAWAL: 'PARTIAL_NOTICE_WITHDRAWAL',
  INCOMPLETE_ORDERS_ON_FULL_NOTICE_WITHDRAWAL:
    'INCOMPLETE_ORDERS_ON_FULL_NOTICE_WITHDRAWAL',
  CASH_ACCOUNT_UNDERFUNDED: 'CASH_ACCOUNT_UNDERFUNDED',
  PLATFORM_EMBARGO: 'PLATFORM_EMBARGO',
  NOM_ACCOUNT_CHANGE: 'NOM_ACCOUNT_CHANGE',
  CUSTOMER_NOT_EXISTS: 'CUSTOMER_NOT_EXISTS',
  INCONSISTENT_PRODUCT_ACCOUNT_ORDER_DATA:
    'INCONSISTENT_PRODUCT_ACCOUNT_ORDER_DATA',
  INCONSISTENT_CUSTOMER_ACCOUNT_ORDER_DATA:
    'INCONSISTENT_CUSTOMER_ACCOUNT_ORDER_DATA',
  INCONSISTENT_CUSTOMER_ORDER_DATA: 'INCONSISTENT_CUSTOMER_ORDER_DATA',
  CUSTOMER_ACCOUNT_NOT_EXISTS: 'CUSTOMER_ACCOUNT_NOT_EXISTS',
} as const;
